// extracted by mini-css-extract-plugin
export default {"asset-detail-view":"wwSV","image-container":"vdul","image":"huF3","content-container":"hhGV","headline":"t4Bb","description":"WThj","asset-details":"aFIQ","button":"PSvF"};